import { useNavigate } from 'react-router-dom'
import styles from './AuthNavBar.module.scss'
import { Icon } from 'components/Icon/Icon'
import { Button } from 'components/Button/Button'
import { useIsMobile } from 'hooks/useIsMobile'

type Props = {
    pathname: string,
}

export function AuthNavBar(props: Props) {
    const navigate = useNavigate()
    const { isMobile } = useIsMobile()

    const buttonText = props.pathname === 'login' ? 'Get started' : 'Log in'
    const navigateUrl = props.pathname === 'login' ? 'signup' : 'login'

    function navigateTo() {
        navigate(`/${navigateUrl}`)
    }

    return (
        <div className={styles['wrapper']}>
            <Icon name={isMobile ? 'drizzle_mini' : 'drizzle'} />
            <Button
                size='xs'
                type='border'
                stretch={false}
                onClick={navigateTo}
            >
                {buttonText}
            </Button>
        </div>
    )
}

